/**
 * Platform-admin "act as tenant". A platform admin may operate inside another
 * tenant (support/setup) — the selected tenant id is stored here and sent as the
 * `X-Act-As-Tenant` header on every request (see fetchClient). The backend only
 * honours it for callers holding platform:admin; everyone else's header is a
 * no-op, so this is fail-safe on the client too.
 */
const KEY = "naas:act-as-tenant";

/** The tenant id currently being acted inside (null = the admin's home tenant). */
export function getActAsTenant(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

/** Switch into (id) or out of (null) a tenant, then reload so /auth/me + every
 *  cached query re-resolve for the target. Lands on the dashboard — the previous
 *  page may reference the old tenant's data. */
export function switchTenant(tenantId: string | null): void {
  try {
    if (tenantId) localStorage.setItem(KEY, tenantId);
    else localStorage.removeItem(KEY);
  } catch {
    /* private mode / storage disabled — the switch just won't persist */
  }
  window.location.assign("/dashboard");
}
